import { styled } from "styled-components";

export const SectionTitleBlock = styled.hgroup`
  margin: 2rem 0;
  color: ${({ theme }) => theme.colors.textBright};
`;
